export default {
    computed: {
        getValueByKeyStatic({ $lang }) {
            return (key, list) => {
                if (!list) return '';
                let obj = list.find(item => item.key == key);
                if (!obj) return '';
                return obj['value' + $lang];
            };
        },
        userTitleStatic() {
            const str = this.$sg.ss.get('userTitle');
            // console.log(JSON.parse(str));
            return JSON.parse(str);
        },
        playerPositionStatic() {
            const str = this.$sg.ss.get('positionList');
            return JSON.parse(str);
        },
    },
    methods: {
        // 公共数据集合
        getCommonData() {
            // 球员位置
            let params1 = { key: 'position' };
            this.$server.getCommonData(params1).then(res => {
                this.$sg.ss.set('positionList', JSON.stringify(res.data));
                this.handleData(res, 'player');
            });
            // // 课程类型
            // this.$server.getCommonData({ key: 'subject' }).then((res) => {
            //     if (res.code == 200 && res.data) {
            //         let arr = [...res.data['in_school'], ...res.data['special']];
            //         this.$sg.ss.set('subjectData', JSON.stringify(arr));
            //     }
            // });
            // // 课程里成绩类型
            // this.$server.getCommonData({ key: 'achievementType' }).then((res) => {
            //     if (res.code == 200) {
            //         this.$sg.ss.set('achievementType', JSON.stringify(res.data));
            //     }
            // });
        },
        // 处理数据
        handleData(oldList, type) {
            if (!oldList) return;
            let list = oldList.data || [];
            let objMap = {};
            list.forEach(item => {
                objMap[item.key] = {
                    label: item.value,
                    labelEn: item.valueEn,
                };
            });
            let value = list.map(item => {
                return {
                    value: item.key,
                    label: item.value,
                    labelEn: item.valueEn,
                };
            });
            let data1 = {
                key: `${type}PositionList`,
                value,
            };
            let data2 = {
                key: `${type}PositionMap`,
                value: objMap,
            };
            this.$store.commit('setStateData', data1);
            this.$store.commit('setStateData', data2);
        },
    },
};
